export default {
  "cod100": "Por favor ingrese el código de la entidad.",
  "cod101": "El código de la entidad no fue encontrado en la base de datos.",
  "cod102": "La combinación código de la entidad y fuente de información ya existe en el archivo.",
  "cod199": "Se produjo un error al cargar el archivo, no fue posible crear una nueva entidad en la plataforma.",
  "cod200": "Por favor ingrese el código de la fuente de información.",
  "cod201": "El código de la fuente de información ya existe en la base de datos.",
  "cod300": "Por favor ingrese la fuente de información.",
  "cod301": "La fuente de información no fue encontrada en la base de datos.",
  "cod302": "La fuente de información no fue encontrada en la base de datos.",
  "cod305": "No se pudo actualizar el usuario. La contraseña y la repetición no coinciden.",
  "cod310": "No se pudo actualizar el usuario. La contraseña no cumple con el formato requerido.",
  "cod311": "No se pudo actualizar el usuario. La contraseña actual no coincide con la del usuario conectado.",
  "cod400": "Por favor ingrese el código de la entidad.",
  "cod401": "El código no fue encontrado en la base de datos.",
  "cod402": "El código ya existe en el archivo.",
  "cod403": "El código ya existe en la base de datos.",
  "cod404": "El código ya existe en la base de datos pero dado de baja.",
  "cod500": "Por favor ingrese el nombre de la entidad.",
  "cod600": "Por favor seleccione al menos un ítem de una categoría.",
  "cod601": "El ítem de la categoría no fue encontrado en la base de datos.",
  "cod602": "El o los ítems categoría no puede ser asignado ya que no pertenecen al de el usuario identificado en el Sistema. (en la creación y edición de un usuario)",
  "cod603": "No es posible realizar esta asignación de categorías. Estos ítems de categorías no pertenecen al usuario identificado en el sistema.",
  "cod700": "Por favor ingrese el polígono de la geozona.",
  "cod701": "Error en creación de polígono",
  "cod800": "Es requerido el ID de la entidad.",
  "cod801": "El ID de la entidad no fue encontrado en la base de datos.",
  "cod802": "La combinación ID de la entidad y fuente de información ya existe en el archivo.",
  "cod803": "La combinación ID de la entidad y fuente de información ya existe en la base de datos.",
  "cod900": "Es requerido el ID de la entidad desconocida.",
  "cod901": "El ID de la entidad desconocida no fue encontrado en la base de datos.",
  "cod994": "Por seguridad no puedes activarte a ti mismo en la plataforma.",
  "cod995": "Por seguridad no puedes desactivarte a ti mismo de la plataforma.",
  "cod999": "Error en el archivo",
  "cod1000": "Es requerido el ID",
  "cod1001": "El ID no fue encontrado en la base de datos.",
  "cod1002": "El ID ya existe en el archivo.",
  "cod1003": "El ID ya existe en la base de datos",
  "cod1004": "El ID ya existe en la base de datos pero dado de baja.",
  "cod1100": "Por favor ingrese la fecha de inicio.",
  "cod1200": "Por favor ingrese el email",
  "cod1201": "El email (username) no fue encontrado.",
  "cod1202": "El email (username) ya existe en la lista de usuarios que desea guardar o actualizar.",
  "cod1203": "El email (username) ya existe en la base de datos.",
  "cod1204": "El email (username) ya existe en la base de datos pero dado de baja.",
  "cod1205": "El email ingresado no tiene un formato válido.",
  "cod1300": "La contraseña es requerida.",
  "cod1301": "La repetición de contraseña es requerida.",
  "cod1302": "Es requerido el ingreso de contraseñas.",
  "cod1303": "Las contraseñas no coinciden.",
  "cod1400": "Por favor ingrese un nombre.",
  "cod1500": "Por favor ingrese al menos un permiso.",
  "cod1501": "Permiso no encontrado en el sistema.",
  "cod1502": "Permiso no encontrado en el sistema.",
  "cod1600": "Por favor indique si el usuario es administrador.",
  "cod6500": "No se puede leer el archivo, error inesperado.",
  "cod6501": "No se pudo cargar o ingresar los datos del archivo. (En el atributo params de la respuesta en formato JSON tiene los detalles).",
  "cod6502": "No se pudo leer el archivo, cabecera incompatible.",
  "cod6503": "Por favor cargue el archivo.",
  "cod6504": "Por favor ingrese datos requeridos en el archivo.",
  "cod6505": "No existe la hoja con los datos en el archivo",
  "cod9000": "Usuario no tiene estos permisos habilitados.",
  "cod9100": "Por seguridad no puedes editarte a ti mismo.",
  "cod10001": "Campo requerido Vehículo.",
  "cod10002": "Campo requerido Conductor.",
  "cod10003": "Campo requerido Gerencia.",
  "cod10004": "Campo requerido Carga.",
  "cod10005": "Campo requerido Dirección.",
  "cod10006": "Campo requerido Fecha y Hora.",
  "cod10007": "Campo requerido Email.",
  "cod10008": "Campo requerido Número Permiso MOP.",
  "cod10009": "Campo requerido Archivo Permiso MOP.",
  "cod10010": "Campo requerido Escolta.",
  "cod10011": "Campo requerido Tipo de Vehículo.",
  "cod10012": "Formato de Email no valido.",
  "cod10013": "La Fecha y Hora no puede ser anterior a HOY a las",
  "cod10014": "La Fecha y Hora no puede ser superior 24 horas desde la hora actual.",
  "cod10015": "Campo Carga no puede ser mayor a 128 caracteres.",
  "cod10016": "Campo Número Permiso MOP no puede ser mayor a 64 caracteres.",
  "cod10017": "Campo Comentarios no puede ser mayor a 1024 caracteres.",
  "cod10018": "Campo Email no puede ser mayor a 128 caracteres.",
  "codTag100": "El ítem ya existe.",
  "codItem100": "El ítem ya existe.",
  "codItem104": "El ítem ya existe.",
  "codItem304": "El ítem ya existe.",
  "codItem303": "El ítem ya existe.",
  "codList100": "La lista ya existe.",
  "codList104": "La lista ya existe.",
  "codGroup500": "Por favor ingrese el nombre del grupo.",
  "codGroup501": "Nombre de grupo inválido (no se soporta el caracter ').",
  "codGroup1001": "Grupo no encontrado en la base de datos.",
  "codGroup1900": "Por favor ingrese el listado de mails.",
  "codGroup1901": "Listado de mails inválido (cada mail debe ir separado por ,).",
  "codGroup503": "El alias ya existe.",
  "codGroup504": "El alias ya existe pero en una entidad desactivada.",
  "codGroup12000": "Es requerido indicar si es o no un turno dinámico.",
  "codGroup13000": "Por favor ingrese la cantidad de días.",
  "codGroup13001": "La cantidad de días está fuera del rango, debe ser mayor o igual a 1.",
  "codGroup14000": "Por favor ingrese la planificación horaria.",
  "codGroup14001": "La planificación horaria no tiene un formato válido, se indicó que es de tipo \"trabajo\" pero no se indicó el horario.",
  "codGroup15000": "Por favor ingrese la fecha de inicio de turno.",
  "codGroup16000": "Por favor ingrese el tiempo máximo para enviar el reporte.",
  "codGroup16001": "El tiempo máximo para enviar el reporte está fuera del rango, debe ser mayor o igual a 1.",
  "codGroup17000": "Por favor ingrese el tiempo máximo para realizar la evaluación después del inicio de jornada.",
  "codGroup17001": "El tiempo máximo para realizar la evaluación después de lo establecido está fuera del rango, debe ser mayor o igual a 1.",
  "codGroup18000": "Por favor ingrese el tiempo máximo para realizar la evaluación antes del inicio de jornada.",
  "codGroup18001": "El tiempo máximo para realizar la evaluación antes de lo establecido está fuera del rango, debe ser mayor o igual a 1.",
  "codGroup14002": "La planificación horaria no tiene un formato válido, al menos debe existir una jornada de tipo \"trabajo\".",
  "codGroup18002": "El tiempo máximo para realizar la evaluación antes de lo establecido no puede ser menor que el tiempo máximo para el envío del reporte.",
  "cod18102": "No existe el grupo de turno.",
  "cod11001": "Formato de fecha inválido en algún campo. Formato valido dd/mm/aaaa.",
  "cod1503": "El rol para gestionar desviaciones no puede ser asignado ya que el usuario no tiene asignado el rol para ver desviaciones.",
  "codTask18200": "Debes completar este campo para cerrar la desviación.",
  "cod605": "No es posible realizar esta acción dado que no cuentas con los permisos suficientes para editar este tipo de usuarios, para realizar esta tarea necesitas un usuario con permisos más elevados",
  "cod606": "No es posible realizar esta acción dado que no cuentas con los permisos suficientes para editar este tipo de usuarios, para realizar esta tarea necesitas un usuario con permisos más elevados",
  "cod1504": "No es posible realizar esta acción dado que no cuentas con los permisos suficientes para editar este tipo de usuarios, para realizar esta tarea necesitas un usuario con permisos más elevados",
  "cod604": "Por favor ingrese al menos un ítem para cada una de las siguientes categorías",
  "apiErrorForm": "Ha ocurrido un error, vuelva a intentarlo.",
  "apiError": "Ha ocurrido un error, vuelva a intentarlo",
  "apiError500": "Ha ocurrido un error, vuelva a intentarlo",
  "noData": "Ha ocurrido un error, vuelva a intentarlo",
  "noSetting": "Sin configuración",
  "cod607": "No se puede asignar más de un ítem por categoría",
  "noAuthorization": "Sin autorización",
  "cod5200": "Has subido un formato de archivo no permitido. Utiliza estos: {list-extensions}"
};


// WEBPACK FOOTER //
// ./source/client/components/locales/language_configuration/escondida/error.js